const blogState = {
  loader : false,
  blogSuccessMessage: "",
  blogErrorMessage: "",
  allblogs: [],
  parPage: 0,
  blogCount: 0,
  sliderBlogs: [],
  recentPost:[],
  singlePost :''
};

export const blogReducer = (state = blogState, action) => {
  const { payload, type } = action;

    if(type === "SET_LOADER"){
      return {
        ...state,
        loader : true
    }
    }
    if(type === 'DHASBOARD_BLOG_ADD_SUCCESS'){
      return {
          ...state,
          loader : false,
          blogSuccessMessage : payload.successMessage,
          blogErrorMessage : ''
      }
  }
  if(type === 'DHASBOARD_BLOG_ADD_FAIL'){
    return {
      ...state,
      loader : false,
      blogErrorMessage : payload,
      blogSuccessMessage : ''
    }
}

  if (type === "PERPAGE_BLOG_GET_SUCCESS") {
    return {
      ...state,
      allblogs: payload.allBlog,
      blogCount: payload.blogCount,
      parPage: payload.parPage,
    };
  }

  if (type === "SLIDER_BLOG_GET_SUCCESS") {
    return {
      ...state,
      sliderBlogs: payload.allSliderBlogs,
    };
  }


  if (type === "RECENT_BLOG_GET_SUCCESS") {
    return {
      ...state,
      recentPost: payload.recentPost,
    };
  }
  if (type === "SINGLE_BLOG_GET_SUCCESS") {
    return {
      ...state,
      singlePost : payload.singlePost
    };
  }
  if (type === "BLOG_DELETE_SUCCESS") {
    return {
      ...state,
      blogSuccessMessage: payload,
      blogErrorMessage : ''
    };
  }
 

  return state;
};
